/*
 * Kibemo tracking – pushes kibemo_* events into window.dataLayer.
 * GTM listens to these names and builds the GA4 events from them.
 * Nothing in here may throw: missing fields are sent as undefined.
 */
(function () {
  window.dataLayer = window.dataLayer || [];

  function push(data) {
    try {
      window.dataLayer.push(data);
    } catch (e) {}
  }

  function toNumber(value) {
    var n = parseFloat(value);
    return isNaN(n) ? undefined : n;
  }

  /* ----------------------------------------------------------------------------------------------------------------
   * Task 1 – product clicks in lists (kibemo_select_item)
   * ---------------------------------------------------------------------------------------------------------------- */

  // Lists outside of collection/search pages are told apart by their section type (the section wrapper id is
  // "shopify-section-<template>__<section-type>...").
  var SECTION_LISTS = [
    ['related-products', 'related_products'],
    ['recently-viewed', 'recently_viewed'],
    ['featured-collections', 'featured_collections'],
    ['featured-collection', 'featured_collection']
  ];

  function listId(card) {
    var path = window.location.pathname;

    if (path.indexOf('/collections/') !== -1 && path.indexOf('/products/') === -1) {
      return path.split('/collections/')[1].split('/')[0] || undefined;
    }

    if (path.indexOf('/search') !== -1) {
      return 'search';
    }

    var section = card.closest('.shopify-section');
    var sectionId = section ? section.id : '';

    for (var i = 0; i < SECTION_LISTS.length; i++) {
      if (sectionId.indexOf(SECTION_LISTS[i][0]) !== -1) {
        return SECTION_LISTS[i][1];
      }
    }

    return path === '/' ? 'home' : 'other';
  }

  function priceOf(card) {
    var attr = card.getAttribute('data-product-price');

    if (attr) {
      return toNumber(attr);
    }

    var el = card.querySelector('price-list') || card.querySelector('[class*="price"]');
    var match = el ? el.textContent.replace(/['’\s]/g, '').match(/(\d+[.,]?\d*)/) : null;

    return match ? toNumber(match[1].replace(',', '.')) : undefined;
  }

  function onProductClick(event) {
    var link = event.target.closest && event.target.closest('a[href*="/products/"]');
    var card = link ? link.closest('product-card') : null;

    if (!card) {
      return;
    }

    var list = card.closest('product-list');
    var cards = list ? Array.prototype.slice.call(list.querySelectorAll('product-card')) : [card];
    var handle = card.getAttribute('data-product-handle') || card.getAttribute('handle') || undefined;
    var titleEl = card.querySelector('.product-card__title a') || card.querySelector('.product-card__title');
    var id = listId(card);
    var name = document.title;

    push({ ecommerce: null });
    push({
      event: 'kibemo_select_item',
      ecommerce: {
        item_list_id: id,
        item_list_name: name,
        items: [{
          // Numeric Shopify product id only – never fall back to the handle (see convention 4)
          item_id: card.getAttribute('data-product-id') || undefined,
          item_name: titleEl ? titleEl.textContent.trim() : handle,
          index: cards.indexOf(card) + 1,
          price: priceOf(card),
          item_list_id: id,
          item_list_name: name
        }]
      }
    });
  }

  document.addEventListener('click', function (event) {
    try {
      onProductClick(event);
    } catch (e) {}
  }, true);

  /* ----------------------------------------------------------------------------------------------------------------
   * Task 2 – pCon configuration completed / abandoned (kibemo_pcon_complete, kibemo_pcon_abandon)
   *
   * The pCon iframe posts { type: 'pcon-message', action: 'add_product', product_id, ... } to the page once a
   * configuration is done (handled for the cart in CartDrawer._onPconAdded in theme.js). There is no abandon signal
   * from pCon: the modal is closed by clicking a [data-pcon-close] element, so a close without a prior result is an
   * abandon. The start is tracked in GTM, hence open() is not called here.
   * ---------------------------------------------------------------------------------------------------------------- */

  window.kibemoPcon = {
    open: function (productId) {
      push({
        event: 'kibemo_pcon_open',
        pcon_product_id: String(productId || '')
      });
    },
    complete: function (productId, details) {
      push({
        event: 'kibemo_pcon_complete',
        pcon_product_id: String(productId || ''),
        pcon_configuration_id: (details && details.configurationId) ? String(details.configurationId) : '',
        pcon_price: (details && typeof details.price === 'number') ? details.price : undefined
      });
    },
    abandon: function (productId, reason) {
      push({
        event: 'kibemo_pcon_abandon',
        pcon_product_id: String(productId || ''),
        pcon_abandon_reason: reason || 'closed'
      });
    }
  };

  // true once a result came back for the current opening of the modal
  var pconCompleted = false;

  function pconModal() {
    return document.querySelector('[data-pcon-modal]');
  }

  function pconProductId() {
    var modal = pconModal();
    return modal ? modal.getAttribute('data-product-id') : undefined;
  }

  document.addEventListener('click', function (event) {
    try {
      if (!event.target.closest) {
        return;
      }

      if (event.target.closest('[data-pcon-open]')) {
        pconCompleted = false;
        return;
      }

      // Capture phase: runs before the theme's close handler flips data-visible to false
      var modal = pconModal();

      if (event.target.closest('[data-pcon-close]') && modal && modal.dataset.visible === 'true' && !pconCompleted) {
        window.kibemoPcon.abandon(pconProductId(), 'closed');
      }
    } catch (e) {}
  }, true);

  window.addEventListener('message', function (event) {
    try {
      var data = event.data;

      if (!data || typeof data !== 'object' || data.type !== 'pcon-message' || data.action !== 'add_product' || !data.product_id) {
        return;
      }

      // pCon may deliver the same result more than once – count it once per opening
      if (pconCompleted) {
        return;
      }

      pconCompleted = true;

      window.kibemoPcon.complete(pconProductId(), {
        // product_id in the message is the variant of the newly created "pcon-created" product
        configurationId: data.product_id,
        price: toNumber(data.price)
      });
    } catch (e) {}
  });

  /* ----------------------------------------------------------------------------------------------------------------
   * Task 3 – quote request with its products (kibemo_quote_submit)
   *
   * Samita Request for Quote keeps its own list in localStorage ("<shop>/samitaRFQ/group_<n>.item_<n>"), separate
   * from the Shopify cart, and empties it once the request went through. The list is therefore read when the submit
   * button is clicked, and the event is only pushed once Samita replaces the form with its thank-you message (which
   * happens 2s before it redirects to /pages/offerte-eingereicht). A request that fails validation keeps the form, so
   * nothing is pushed for it.
   * ---------------------------------------------------------------------------------------------------------------- */

  var QUOTE_ITEM_KEY = /\/samitaRFQ\/group_\d+\.item_\d+$/;

  function decode(value) {
    try {
      return decodeURIComponent(value);
    } catch (e) {
      return value;
    }
  }

  function quoteItems() {
    var items = [];

    for (var i = 0; i < window.localStorage.length; i++) {
      var key = window.localStorage.key(i);

      if (!QUOTE_ITEM_KEY.test(key)) {
        continue;
      }

      try {
        var item = JSON.parse(window.localStorage.getItem(key));
        var price = toNumber(item.price);

        items.push({
          item_id: item.product_id ? String(item.product_id) : undefined,
          item_name: item.name ? decode(item.name) : undefined,
          item_variant: item.variant_name ? decode(item.variant_name) : undefined,
          quantity: toNumber(item.qty),
          // Samita stores prices in Rappen
          price: price === undefined ? undefined : price / 100
        });
      } catch (e) {}
    }

    return items;
  }

  var pendingQuoteItems = null;
  var quoteObserver = null;

  function pushQuoteIfSubmitted() {
    // On success Samita marks the page "text-center" and swaps the form for its thank-you message. Both are checked so
    // a re-render of the form (e.g. after a quantity change) is not mistaken for a submit.
    if (!pendingQuoteItems || !document.querySelector('.rfq_form_page.text-center') || document.getElementById('grfq-form')) {
      return;
    }

    var items = pendingQuoteItems;
    pendingQuoteItems = null;

    if (quoteObserver) {
      quoteObserver.disconnect();
      quoteObserver = null;
    }

    push({ ecommerce: null });
    push({
      event: 'kibemo_quote_submit',
      ecommerce: {
        items: items
      }
    });
  }

  document.addEventListener('click', function (event) {
    try {
      if (!event.target.closest || !event.target.closest('#grfq-form [name="submitRFQForm"]')) {
        return;
      }

      pendingQuoteItems = quoteItems();

      if (!quoteObserver && window.MutationObserver) {
        quoteObserver = new MutationObserver(function () {
          try {
            pushQuoteIfSubmitted();
          } catch (e) {}
        });

        quoteObserver.observe(document.body, { childList: true, subtree: true });
      }
    } catch (e) {}
  }, true);
})();
